var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full p-3 text-center",class:_vm.classVariant},[(_vm.$slots.default)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }